import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { INutrientSlurryPlanExcretaCollection } from './nutrient-slurry-plan-excreta-collection.model';

@Injectable()
export class NutrientSlurryPlanExcretaCollectionService {
  constructor(private apiService: ApiService) {}

  saveNutrientSlurryPlanExcretaCollections(
    nutrientSlurryPlanExcretaCollections: INutrientSlurryPlanExcretaCollection[]
  ): Promise<any> {
    if (nutrientSlurryPlanExcretaCollections.length === 0)
      return Promise.resolve();
    return this.apiService.post(
      'v1/nutrient-slurry-plan-excreta-collections',
      nutrientSlurryPlanExcretaCollections
    );
  }
}
